// import PoziAPIData from 'api/data'
import memoize from 'lodash/memoize'

/**
 * Helper/Utility functions
 */
const PoziHelpers = memoize(function () {
  // ============================================================
  // Public Variables
  // ============================================================

  /**
   * This object
   * @type {object}
   */
  const __ = this

  __.ieVersion = 0

  // ============================================================
  // Private Variables
  // ============================================================

  // ============================================================
  // Public Functions
  // ============================================================

  __.init = function () {
    __.redirectIfSupportDomain()

    // console.log("init helpers")
    // Store a reference to the IE version, or 0 for not IE.
    if (__.detectIE() !== false) {
      __.ieVersion = __.detectIE()
      __.ieVersion = __.ieVersion * 1
    }
    // console.log("IEVersion: " + __.ieVersion)
  }

  __.checkSVGSupport = function () {}

  // Redirect support domain to /docs.html
  __.redirectIfSupportDomain = function () {
    try {
      let url = window.location.host
      if (url.toLowerCase().indexOf('support.pozi.com') > -1) {
        url = 'https://support.pozi.com/docs.html'
        window.location = url
      }
    } catch (e) {}
  }

  __.inIframe = function () {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  }

  // Get IE or Edge browser version
  // https://codepen.io/gapcode/pen/vEJNZN
  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  __.detectIE = function () {
    const ua = window.navigator.userAgent

    // Test values Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible MSIE 10.0 Windows NT 6.2 Trident/6.0)'

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3 Trident/7.0 rv:11.0) like Gecko'

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0 WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0'

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0 Win64 x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586'

    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }

    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:')
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    }

    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    }

    // other browser
    return false
  }

  // ============================================================
  // Private Functions
  // ============================================================
})

// Helper functions

// TODO: Remove this global function!

function index(obj, i) {
  return obj[i]
}

// TODO: Remove this global function!

function ajaxFail(jqxhr, textStatus, error) {
  const err = textStatus + ', ' + error
  console.error('Ajax request failed: ' + err)
}

// TODO: Remove this global function!

Date.prototype.filestamp = function() {
  const d = this
  const currYear = d.getFullYear()

  let currDate = d.getDate() + ''
  if (currDate.length === 1) currDate = '0' + currDate

  let currMonth = d.getMonth() + 1 + ''
  if (currMonth.length === 1) currMonth = '0' + currMonth

  let currHr = d.getHours() + ''
  if (currHr.length === 1) currHr = '0' + currHr

  let currMin = d.getMinutes() + ''
  if (currMin.length === 1) currMin = '0' + currMin

  let currSec = d.getSeconds() + ''
  if (currSec.length === 1) currSec = '0' + currSec

  return currYear + '' + currMonth + '' + currDate + '' + currHr + '' + currMin + '' + currSec
}

// TODO: Remove this global function!

Date.prototype.getDateYearMonthDay = function() {
  const d = this
  const currYear = d.getFullYear()

  let currDate = d.getDate() + ''
  if (currDate.length === 1) currDate = '0' + currDate

  /* const monthNamesLong = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
  ]; */
  const monthNamesShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return currDate + '-' + monthNamesShort[d.getMonth()] + '-' + currYear
}

export default PoziHelpers

/*
$.cachedScript = function (url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend(options || {}, {
    dataType: 'script',
    cache: true,
    url: url
  })

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return PoziAPIData().ajax(options)
} */

// Define a jQuery function to serialize a form into a JSON object
// Source: https://css-tricks.com/snippets/jquery/serialize-form-to-json/
/* $.fn.serializeObject = function () {
  var o = {}
  var a = this.serializeArray()
  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]]
      }
      o[this.name].push(this.value || '')
    } else {
      o[this.name] = this.value || ''
    }
  })
  return o
} */
